import React, { useContext } from "react";
import { useState, useEffect, useRef } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";
// *******************toster****************************
import Card from "react-bootstrap/Card";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import JoditEditor from "jodit-react";
import { useForm } from "react-hook-form";
import classNames from "classnames";
library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData, IMG_URL, getDimension } = useContext(Context);

  const id = props.show;
  // const [data, setData] = useState();

  // const editor = useRef(null);
  // const [formData, setFormData] = useState({
  //   name: "",
  //   image: "",
  // });
  // const [imagePreview, setImagePreview] = useState(null);
  // const [content, setContent] = useState("");
  // const [errors, setErrors] = useState();
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  // const handleChange = async (e) => {
  //   if (e.target.name === "image") {
  //     const data = new FormData();
  //     data.append("image", e.target.files[0]);
  //     data.append("width", 313);
  //     data.append("height", 252);
  //     const checkimage = await postData("/image", data);

  //     if (!checkimage?.success) {
  //       await setError({ image: checkimage?.message });
  //     } else {
  //       const newFormData = {
  //         ...formData,
  //         image: e.target.files[0],
  //         imageUrl: URL.createObjectURL(e.target.files[0]),
  //       };
  //       await setError({ image: null });
  //       await setFormData(newFormData);
  //     }
  //   } else {
  //     setFormData({ ...formData, [e.target.name]: e.target.value });
  //   }
  // };
  // const [error, setError] = useState({
  //   image: null,
  // });

  // const validateForm = () => {
  //   let errors = {};
  //   const regexNumeric = /^[0-9]+$/;
  //   const regexAlfaNumric = /^[A-Za-z0-9]+(\s[A-Za-z0-9]+)*$/;
  //   const regexAlfa = /^[A-Za-z]+(\s[A-Za-z]+)*$/;

  //   if (!formData.name) {
  //     errors.name = "name is required";
  //   }
  //   if (!formData.image) {
  //     errors.image = "Image is required";
  //   }

  //   // Add more validations as needed

  //   return errors;
  // };

  // const errorStyle = {
  //   color: "red",
  //   marginLeft: "5px",
  //   // fontSize: "11px",
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const validationErrors = validateForm();

  //   if (Object.keys(validationErrors).length > 0) {
  //     setErrors(validationErrors);
  //   } else {
  //     try {
  //       console.log("FormData", formData);
  //       const formDataToSend = new FormData();
  //       formDataToSend.append("name", formData?.name);
  //       formDataToSend.append("image", formData?.image);

  //       const response = await postData(
  //         `/masters/our_popular_courses/${id}`,
  //         formDataToSend
  //       );
  //       console.log("Data to be sent :- ", response);
  //       if (response?.success) {
  //         setShowModal({ code: response.code, message: response.message });
  //         setTimeout(() => {
  //           setShowModal(0);
  //           props.handleClose();
  //         }, 1000);
  //       } else {
  //         setShowModal({ code: response.code, message: response.message });
  //         setTimeout(() => {
  //           setShowModal(0);
  //           props.handleClose();
  //         }, 1000);
  //       }
  //     } catch (error) {
  //       console.error("Error submitting form:", error);
  //     }
  //   }
  // };

  const GetEditData = async () => {
    const response = await getData(`/masters/course-type/${id}`);
    console.log(response?.data);
    reset(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    reset,
    watch,
  } = useForm();
  console.log(getValues());
  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      const fromData = new FormData();
      fromData.append("name", data?.name);
      fromData.append("url", data?.url);

      //   if (typeof data?.image !== "string") {
      //     fromData.append("image", data?.image[0]);
      //   }
      const response = await postData(`/masters/course-type/${id}`, fromData);
      console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        onHide={props.handleClose}
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Course Type
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
            className="countryclass"
          >
            <Row>
              {/* Title */}
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label column sm={3} className="text-center">
                      Title
                    </Form.Label>
                    <Col sm={9}>
                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          type="text"
                          {...register("name", {
                            required: "Title is required",
                          })}
                          placeholder="Title"
                        />
                      </Form.Group>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                              <div className="main-form-section mt-3">
                                <Row className="justify-content-center">
                                  <Form.Label column sm={3} className="text-center">
                                    URL
                                  </Form.Label>
                                  <Col sm={9}>
                                    <Form.Group>
                                      <Form.Control
                                        className={classNames("", {
                                          "is-invalid": errors?.url,
                                        })}
                                        type="text"
                                        {...register("url", {
                                          required: "URL is required",
                                        })}
                                        placeholder="URL"
                                      />
                                    </Form.Group>
                                    {errors.url && (
                                      <span className="text-danger">
                                        {errors.url.message}
                                      </span>
                                    )}
                                  </Col>
                                </Row>
                              </div>
                            </Col>

              {/* Image Upload */}
              {/* <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label column sm={3} className="text-center">
                      Image
                    </Form.Label>
                    <Col sm={9}>
                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.image,
                          })}
                          type="file"
                          {...register("image", {
                            validate: async (value) => {
                              console.log(value);
                              if (typeof value !== "string") {
                                const fileTypes = ["jpg", "png", "jpeg", "JPG"];
                                const fileType = value[0]?.name?.split(".")[1];

                                if (!fileTypes.includes(fileType)) {
                                  // return `please upload a valid file format. (${fileTypes})`;
                                }

                                const sizes = await getDimension(value[0]);
                                if (
                                  sizes.width !== 300 &&
                                  sizes.height !== 324
                                ) {
                                  // return "Image width and height must be 300px and 324px";
                                }

                                const fileSize = Math.round(
                                  value[0].size / 1024
                                );
                                if (fileSize > 500) {
                                  // return "file size must be lower than 500kb";
                                }
                              }
                            },
                          })}
                          accept=".jpg, .jpeg, .png"
                        />
                      </Form.Group>
                      {errors.image && (
                        <span className="text-danger">
                          {errors.image.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col> */}

              {/* Image Preview */}
              {/* <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label column sm={3} className="text-center">
                      Image Preview
                    </Form.Label>
                    <Col sm={9}>
                      {typeof getValues("image") == "string" ? (
                        <div className="image-preview-container">
                          <img
                            src={IMG_URL + getValues("image")}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "100px", height: "100px" }}
                          />
                        </div>
                      ) : (
                        imageFile &&
                        imageFile?.length > 0 && (
                          <div className="image-preview-container">
                            <img
                              // src={URL.createObjectURL(getValues("image")[0])}
                              src={URL?.createObjectURL(imageFile[0])}
                              alt="Preview"
                              className="image-preview"
                              style={{ width: "100px", height: "100px" }}
                            />
                          </div>
                        )
                      )}
                    </Col>
                  </Row>
                </div>
              </Col> */}
            </Row>

            {/* Buttons */}
            <Row className="justify-content-center mt-5 pb-3">
              <Col sm={6} className="d-flex justify-content-center">
                <CancelButton name={"Cancel"} handleClose={props.handleClose} />
                <SaveButton
                  name={"Save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
